import styles from './authMarketingSideFallback.module.scss';
import ExampleMarketingSkeleton from './ExampleMarketingSkeleton';
import LoginMarketingSkeleton from './LoginMarketingSkeleton';

/**
 * Skeleton for lazy-loaded auth marketing panels.
 * @param {'login' | 'example'} [variant] — `login` matches LoginSideContent; `example` matches ClockoutExampleSection.
 */
export default function AuthMarketingSideFallback({ variant = 'example' }) {
    return (
        <div className={styles.banner} aria-busy="true" aria-label="Loading preview">
            <div className={styles.card}>
                {variant === 'login' ? <LoginMarketingSkeleton /> : <ExampleMarketingSkeleton />}
            </div>
        </div>
    );
}
